import { toResizedJpegBlob } from './toResizedJpeg'

// 問診票の読み取り API と同じ上限 (管理栄養士の報告書の生成は添付をまとめて 1 回で渡す)
export const PDF_MAX_BYTES = 10 * 1024 * 1024

// 選んだ・落としたファイルを送る形にする。スキャンの PDF は縮めずにそのまま、写真は長辺を縮めた JPEG。
// 送れないときは Error を投げる (message は画面にそのまま出す文言)。
export const fileToAttachment = async (file: File): Promise<Blob> => {
  if (file.type === 'application/pdf') {
    if (file.size > PDF_MAX_BYTES) {
      throw new Error('PDF は 10MB までにしてください。')
    }
    return file
  }
  const url = URL.createObjectURL(file)
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const i = new Image()
      i.onload = () => resolve(i)
      i.onerror = () => reject(new Error('画像を読込めませんでした'))
      i.src = url
    })
    return await toResizedJpegBlob(img)
  } finally {
    URL.revokeObjectURL(url)
  }
}
